export default {
  personeelslid: {
    objectName: "Identificatie",
    naam: "Naam",
    voornaam: "Voornaam",
    voornaam2: "Overige voorna(a)m(en)",
    roepnaam: "Roepnaam",
    geboortedatum: "Geboortedatum",
    geboorteplaats: "Geboorteplaats",
    geboorteland: "Geboorteland",
    persMindervalide: "Mindervalide",
    geslacht: "Geslacht",
    initialen: "Initialen",
    werknemerscode: "Werknemerscode",
    stamnummer: "Stamnummer",
    contrStamnummer: "Contractueel stamnummer",
    inszNr: "INSZ-nummer",
    natio: {
      objectName: {
        singular: "Nationaliteit",
        plural: "Nationaliteiten",
      },
      natType: "Nationaliteitstype",
      nationaliteit: "Nationaliteit",
    },
  },
  contact: {
    objectName: "Contact",
    woonplaats: {
      objectName: {
        singular: "Woonplaats",
        plural: "Woonplaatsen",
      },
      straat: "Straat",
      nr: "Huisnummer",
      bus: "Bus",
      hfdPostnr: "Postcode",
      deelgemeente: "Gemeente",
    },
    correspondentie: {
      objectName: {
        singular: "Correspondentieadres",
        plural: "Correspondentieadressen",
      },
      straat: "Straat",
      nr: "Huisnummer",
      bus: "Bus",
      hfdPostnr: "Postcode",
      deelgemeente: "Gemeente",
    },
    verblijfplaats: {
      objectName: {
        singular: "Verblijfplaats",
        plural: "Verblijfplaatsen",
      },
      straat: "Straat",
      nr: "Huisnummer",
      bus: "Bus",
      hfdPostnr: "Postcode",
      deelgemeente: "Gemeente",
    },
    comnummer: {
      objectName: {
        singular: "Telefoonnummer",
        plural: "Telefoonnummers",
      },
      prefix: "Prefix",
      nummer: "Nummer",
      type: "Type",
      soort: "Soort",
    },
    email: {
      objectName: {
        singular: "Privé e-mailadres",
        plural: "Privé e-mailadressen",
      },
      emailAdres: "Privé e-mailadres",
    },
    werkEmail: {
      objectName: {
        singular: "Werk e-mailadres",
        plural: "Werk e-mailadressen",
      },
      emailAdres: "Werk e-mailadres",
    },
  },
  gezin: {
    objectName: "Gezinstoestand",
    burgStaat: {
      objectName: "Burgerlijke staat",
      burgstaat: "Burgerlijke staat",
      burgstaatDatum: "Burgerlijke staat",
      huwelijksdatum:"Datum huwelijk / wet.sam."
    },
    partner: {
      objectName: "Partner",
      naam: "Naam",
      voornaam: "Voornaam",
      nationaliteit: "Nationaliteit",
      geboortedatum: "Geboortedatum",
      geboorteplaats: "Geboorteplaats",
      beroep: "Beroep",
      werkgever: "Werkgever",
      overlijdensdatum: "Overlijdensdatum",
    },
    gezinsleden: {
      objectName: {
        singular: "Overig gezinslid",
        plural: "Overige gezinsleden",
      },
      naam: "Naam",
      voornaam: "Voornaam",
      geboortedatum: "Geboortedatum",
      overlijdensdatum: "Overlijdensdatum",
      mindervalide: "Mindervalide",
      zorgbehoevend: "Zorgbehoevend",
      tenLaste: "Ten laste",
      nietMeerTenLaste: "Datum niet meer ten laste",
      verwantschap: "Verwantschap",
    },
  },
  overige: {
    objectName: "Overige",
    rekening: {
      objectName: {
        singular: "Rekening",
        plural: "Rekeningen",
      },
      iban: "Rekeningnummer",
      bic: "BIC-code",
    },
    rijbewijs: "In bezit van rijbewijs",
    nummerplaat: "Nummerplaat",
    nummerplaten: "Nummerplaten",
    orcid: "ORCID",
  },
};
